export default [
  {
    name: 'project_share',
    component_path: 'modules/templates/blocks/project/ProjectShare'
  }
]